import * as __SNOWPACK_ENV__ from '../../_snowpack/env.js';

import {BrowserMicroSentryClient} from "../../_snowpack/pkg/@micro-sentry/browser.js";
export const sentryClient = new BrowserMicroSentryClient({
  dsn: __SNOWPACK_ENV__.SNOWPACK_PUBLIC_SENTRY_DSN,
  environment: __SNOWPACK_ENV__.SNOWPACK_PUBLIC_FRONTEND_ENV,
  beforeSend(event) {
    event.request = {
      url: location.href,
      headers: {
        "User-Agent": navigator.userAgent
      }
    };
    return event;
  }
});
sentryClient.setTag("part", "host");
export const addSentryTags = (obj) => {
  sentryClient.setTags(obj);
};
